import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { verifyDevEnvironment, showDevIndicator } from './environment';

const rootElement = document.getElementById('root');
showDevIndicator();
verifyDevEnvironment().then(() => createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)).catch(error => { rootElement.textContent = `Development environment unavailable: ${error.message}`; });
